module.exports = __webpack_public_path__ + "img/graduation-la-cite-v2.21602ac8.jpg";